var mapModals = {
  confirmDeleteDrawing: function(translations) {
    var modal;

    modal =   '<div class="modal" id="confirmDeleteDrawingModal" tabindex="-1">';
    modal +=    '<div class="modal-dialog modal-sm c-modal">';
    modal +=      '<div class="c-modal__header">';
    modal +=        '<div class="t-title--large">';
    modal +=          translations.delete_shape;
    modal +=        '</div>';
    modal +=      '</div>'
    modal +=      '<div class="c-modal__content">';
    modal +=          translations.discard_warning_message;
    modal +=      '</div>';
    modal +=      '<div class="c-modal__footer">';
    modal +=        '<button type="button" id="cancelDeleteDrawingBtn" class="btn btn-tertiary" data-dismiss="modal">';
    modal +=          translations.cancel;
    modal +=        '</button>';
    modal +=        '<button type="button" id="deleteDrawingBtn" class="btn btn-primary" data-dismiss="modal">';
    modal +=          translations.yes_im_sure;
    modal +=        '</button>';
    modal +=      '</div>';
    modal +=    '</div>';
    modal +=  '</div>';

    return modal;
  },

  drawnShapeManagementMenu: function(translations) {
    var modal;
    modal =
    `<div id="drawnShapeManagementMenu" class="shape-context-menu context-menu" data-controller="drawn-shape" data-action="focusin->drawn-shape#activateTimeShield">
      <input id="drawnShapeCondition" type="hidden">
      <ul style="list-style-type: none; padding: 0 8px; margin: 0;">
        <li class="shape-context-menu-list-item">
          <div class="form-group">
            <label for="drawnShapeName">Shape Name</label>
            <input class="form-control" id="drawnShapeName" type="text" placeholder="Shape Name" data-action="blur->drawn-shape#changeName">
         </div>
        </li>

        <li class="shape-context-menu-list-item">
          <div class="form-group">
            <label for="drawnShapeColor">Shape Color</label>
            <div id="drawnShapeColor" class="selected-color-outer" data-action="click->drawn-shape#toggleColorSelection keydown.enter->drawn-shape#toggleColorSelection" tabindex="0" role="button">
              <div class="selected-color-inner" data-color="#000000"></div>
              <span class="flexicon flexicon-chevron--small flexicon-90 drawnShapeColorToggle"></span>
            </div>
            <div id="colorChoices" class="hidden" style="padding: 4px; left: 0px; top: 0px">
              <label style="margin-left: 8px;">Select A Color</label>
              <div>
                <div style="display: flex;">
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#0069ff">
                    <div class="color-choice-inner" style="background: #0069ff;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#006600">
                    <div class="color-choice-inner" style="background: #006600;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#4a0000">
                    <div class="color-choice-inner" style="background: #4a0000;"></div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#cc0000">
                    <div class="color-choice-inner" style="background: #cc0000;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#ffff00">
                    <div class="color-choice-inner" style="background: #ffff00;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#cc6600">
                    <div class="color-choice-inner" style="background: #cc6600;"></div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#000000">
                    <div class="color-choice-inner" style="background: #000000;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#ff00ff">
                    <div class="color-choice-inner" style="background: #ff00ff;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#00ffff">
                    <div class="color-choice-inner" style="background: #00ffff;"></div>
                  </div>
                </div>
                <div style="display: flex;">
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#00cc00">
                    <div class="color-choice-inner" style="background: #00cc00;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#selectColor" data-color="#ff3399">
                    <div class="color-choice-inner" style="background: #ff3399;"></div>
                  </div>
                  <div class="color-choice-outer" data-action="click->drawn-shape#toggleColorSelection" style="display: flex; justify-content: center; align-items: center;" title="Close Color Selector">
                    <span class="flexicon flexicon-close--large" style="color: #0077d9"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="shape-context-menu-list-item">
          <a href="#" id="shapeMenuEditShape" class="shape-context-menu-item" data-action="click->drawn-shape#editShape"> Edit Shape </a>
        </li>
        <li class="shape-context-menu-list-item">
          <a href="#" id="shapeMenuDeleteShape" class="shape-context-menu-item"> Delete Shape </a>
        </li>
      </ul>
    </div>`

    return modal;
  }
}


export default mapModals;
